<template>
  <v-container>
    <div>
      <template>
        <v-dialog v-model="dialog" width="876" persistent>
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{
                  geneticWorthTraits.id
                    ? this.$t('editCurrentRecord')
                    : this.$t('addNewRecord')
                }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-toolbar
              class="bdr secondary2light mt-4 ml-4"
              style="width: 80%"
              :elevation="0"
              outlined
              v-if="geneticWorthTraits.id"
            >
              <v-toolbar-title
                class="grey--text text--darken-2"
                style="font-size: 13px"
                >{{ $t('sureToEditRecord') }}
              </v-toolbar-title>
            </v-toolbar>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="submit"
              style="padding: 20px"
            >
              <v-row>
                <v-col cols="6">
                  <label class="label">{{ $t("breedingValue") }}</label>
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t(
                        "animal.performanceInfo.averageAmountWeightAnimalGainFeedingPeriod"
                      )
                    }}</span>
                  </v-tooltip>
                  <div class="d-flex">
                    <v-text-field
                      :min="0"
                      type="text"
                      outlined
                      dense
                      :placeholder="$t('enterValue')"
                      v-model="geneticWorthTraits.DPYBValue"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="6">
                  <label class="label">{{ $t("valueBIFAccuracy") }}</label>
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t(
                        "animal.performanceInfo.averageAmountWeightAnimalGainFeedingPeriod"
                      )
                    }}</span>
                  </v-tooltip>
                  <div class="d-flex">
                    <v-text-field
                      :min="0"
                      type="text"
                      outlined
                      dense
                      :placeholder="$t('enterValue')"
                      v-model="geneticWorthTraits.DPYBValueAccuracy"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="6">
                  <label class="label">
                    {{ $t("valuePercentile") }}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>{{ $t('valuePercentileT') }}</span>
                    </v-tooltip>
                  </label>

                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        outlined
                        dense
                        :placeholder="$t('enterValue')"
                        :min="0"
                        type="number"
                        step="any"
                        v-model="geneticWorthTraits.DPYBValuePercent"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        :items="valuePercentileUnitOptions"
                        outlined
                        dense
                        placeholder="Unit"
                        v-model="geneticWorthTraits.DPYBValuePercentUnit"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <label class="label">
                    {{ $t("valueRank") }}
                    <v-tooltip top color="black" max-width="350">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>
                        The estimated or recorded weight of an animal at its
                        full adult size or maturity.
                      </span>
                    </v-tooltip>
                  </label>

                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        outlined
                        dense
                        placeholder="Value Rank"
                        :min="0"
                        step="any"
                        type="number"
                        v-model="geneticWorthTraits.DPYBValueRank"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-select
                        :items="ValueRankUnitOptions"
                        outlined
                        dense
                        placeholder="Unit"
                        v-model="geneticWorthTraits.DPYBValueRankUnit"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-card-actions style="padding: 20px">
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  class="mr-2"
                  right
                  height="44"
                  width="116"
                  depressed
                  color="primary"
                  @click="closeModal"
                >
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn
                  right
                  height="44"
                  width="116"
                  color="primary"
                  type="submit"
                >
                  {{ geneticWorthTraits.id ? $t("update") : $t("submit") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";

export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
    weights: () => ["kg", "lbs"],
    valuePercentileUnitOptions: () => ["%"],
    ValueRankUnitOptions: () => ["th"],
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      if (
        this.geneticWorthTraits.DPYBValue == null &&
        this.geneticWorthTraits.DPYBValueAccuracy == null &&
        this.geneticWorthTraits.DPYBValuePercent == null &&
        this.geneticWorthTraits.DPYBValuePercentUnit == null &&
        this.geneticWorthTraits.DPYBValueRank == null &&
        this.geneticWorthTraits.DPYBValueRankUnit == null
      ) {
        this.$notify({
          //title: `No details entered.`,
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      this.startLoading();

      const mutation =
        this.geneticWorthTraits && this.geneticWorthTraits.id
          ? `mutation ($data: UpdateGenericWorthTraitsInput!) {
                    updateGeneticWorthTraitsRecord(updateGeneticWorthTraitsInput: $data) {
                        id
                    }
                    }`
          : `mutation ($data: CreateGeneticWorthTraitsInput!) {
                    createGeneticWorthTraitsRecord (createGeneticWorthTraitsInput: $data) {
              id
            }
          }`;

      let payload = {
        animalId: parseInt(this.$route.params.animal_number),
        DPYBValue: parseFloat(this.geneticWorthTraits.DPYBValue) ?? null,
        DPYBValueAccuracy:
          parseFloat(this.geneticWorthTraits.DPYBValueAccuracy) ?? null,
        DPYBValuePercent:
          parseFloat(this.geneticWorthTraits.DPYBValuePercent) ?? null,
        DPYBValuePercentUnit:
          this.geneticWorthTraits.DPYBValuePercentUnit ?? null,
        DPYBValueRank:
          parseFloat(this.geneticWorthTraits.DPYBValueRank) ?? null,
        DPYBValueRankUnit: this.geneticWorthTraits.DPYBValueRankUnit ?? null,
      };

      if (this.geneticWorthTraits.id) {
        payload.id = parseInt(this.geneticWorthTraits.id);
      }
      this.$apollo
        .mutate({
          mutation: gql`
            ${mutation}
          `,
          variables: {
            data: payload,
          },
        })
        .then((res) => {
          let msg = "added";

          if (this.geneticWorthTraits.id) {
            msg = "updated";
          }
          if (res.data) {
            this.$notify({
              title: `Genetic Worth Traits record ${msg} successfully`,
              text: res.message,
              type: "success",
              position: "top right",
            });

            this.$emit("onUpdate");
          } else {
            this.$notify({
              title: `Genetic Worth Traits Record Not ${msg}`,
              text: res.message,
              type: "error",
              position: "top right",
            });
          }
          this.stopLoading();
          this.closeModal();
        })
        .catch((err) => {
          this.$notify({
            text: "Something went wrong.",
            type: "error",
            position: "top right",
          });
          console.log(err.data);
          this.stopLoading();
          this.closeModal();
        });
    },
  },
  data() {
    return {
      geneticWorthTraits: {
        id: null,
        DPYBValue: null,
        DPYBValueAccuracy: null,
        DPYBValuePercent: null,
        DPYBValuePercentUnit: null,
        DPYBValueRank: null,
        DPYBValueRankUnit: null,
      },
      valid: true,
    };
  },
  mounted() {
    if (this.geneticWorthTraitItem) {
      this.geneticWorthTraits.id = this.geneticWorthTraitItem.id;
      this.geneticWorthTraits.DPYBValue = this.geneticWorthTraitItem.DPYBValue;
      this.geneticWorthTraits.DPYBValueAccuracy =
        this.geneticWorthTraitItem.DPYBValueAccuracy;
      this.geneticWorthTraits.DPYBValuePercent =
        this.geneticWorthTraitItem.DPYBValuePercent;
      this.geneticWorthTraits.DPYBValuePercentUnit =
        this.geneticWorthTraitItem.DPYBValuePercentUnit;
      this.geneticWorthTraits.DPYBValueRank =
        this.geneticWorthTraitItem.DPYBValueRank;
      this.geneticWorthTraits.DPYBValueRankUnit =
        this.geneticWorthTraitItem.DPYBValueRankUnit;
    }
  },
  props: ["dialogI", "geneticWorthTraitItem"],
  mixins: [loadingMixin],
};
</script>

<style scoped>
::v-deep .v-messages__message {
  line-height: 12px;
  word-break: break-word;
  /* overflow-wrap: break-word; */
  word-wrap: break-word;
  -webkit-hyphens: auto;
  hyphens: auto;
  white-space: nowrap;
}
</style>
